import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../app/redux/slices/authSlice';
import { useNavigate } from 'react-router-dom';
import Navigation from '../app/components/NavigationSPA';
import { useTranslation } from 'react-i18next';

// Account components that we'll create
import AccountBox from '../app/components/AccountBox';
import AccountFeatures from '../app/components/AccountFeatures';
import AccountThreshold from '../app/components/AccountThreshold';
import AccountEmail from '../app/components/AccountEmail';

export default function AccountPage() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation('account');

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    setIsLoading(false);
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="space-y-8">
            {/* Account Information Section */}
            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-lg font-medium text-gray-900">{t('accountInformation')}</h2>
              </div>
              <div className="p-6">
                <AccountBox />
              </div>
            </div>

            {/* Account Features Section */}
            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-lg font-medium text-gray-900">{t('accountFeatures')}</h2>
              </div>
              <div className="p-6">
                <AccountFeatures />
              </div>
            </div>

            {/* Threshold Settings Section */}
            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-lg font-medium text-gray-900">{t('thresholdSettings')}</h2>
              </div>
              <div className="p-6">
                <AccountThreshold />
              </div>
            </div>

            {/* Email Notifications Section */}
            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-lg font-medium text-gray-900">{t('emailNotifications')}</h2>
              </div>
              <div className="p-6">
                <AccountEmail />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
